import React, {
  useMemo
} from 'react'

import {
  FormGroup,
  Label,
  Input,
} from 'reactstrap'

import Select from 'react-select';

import FieldError from '../helper/FieldError';

import {
  inputId,
  inputName,
} from '../helper/form'

const RequireDefaultBulkRequestConfigForm = React.memo((props) => {

  const {
    defaultBulkRequestConfig,
    setResource,
    data,
    configuration: { formName, context }
  } = props;

  const handleDefaultBulkRequestConfig = (event, key) => {
    let value = event.target.value;

    setResource(prevState => {
      return {
        ...prevState,
        default_bulk_request_config: {
          ... prevState.default_bulk_request_config, [key]: value
        }
      }
    })
  }

  const uploadFileUserRadio = () => {
    return(
      <div className="form-check">
        <Input
          type='radio'
          className='form-check-input'
          name={ inputName(formName, 'uploaded_by') }
          id={ inputId(formName, 'uploaded_by_upload_file_user') }
          value={ 'upload_file_user' }
          checked={ defaultBulkRequestConfig?.uploaded_by == 'upload_file_user' }
          onChange={ e => handleDefaultBulkRequestConfig(e, 'uploaded_by') }
          invalid={ _.has(defaultBulkRequestConfig.errors, 'uploaded_by') }
        />
        <Label
          className='form-check-label'
          for={ inputId(formName, 'uploaded_by_upload_file_user') }
        >
          { I18n.t('activerecord.attributes.laboral/document_type.uploaded_by.upload_file_user') }
        </Label>
      </div>
    )
  }

  const uploadFileEmployeeRadio = () => {
    if(context == 'laboral'){
      return(
        <div className="form-check">
          <Input
            type='radio'
            className='form-check-input'
            name={ inputName(formName, 'uploaded_by') }
            id={ inputId(formName, 'uploaded_by_upload_file_employee') }
            value={ 'upload_file_employee' }
            checked={ defaultBulkRequestConfig?.uploaded_by == 'upload_file_employee' }
            onChange={ e => handleDefaultBulkRequestConfig(e, 'uploaded_by') }
            invalid={ _.has(defaultBulkRequestConfig.errors, 'uploaded_by') }
          />
          <Label
            className='form-check-label'
            for={ inputId(formName, 'uploaded_by_upload_file_employee') }
          >
            { I18n.t('activerecord.attributes.laboral/document_type.uploaded_by.upload_file_employee') }
          </Label>
        </div>
      )
    }
  }

  const uploadFileClientRadio = () => {
    if(context == 'corporate'){
      return(
        <div className="form-check">
          <Input
            type='radio'
            className='form-check-input'
            name={ inputName(formName, 'uploaded_by') }
            id={ inputId(formName, 'uploaded_by_upload_file_client') }
            value={ 'upload_file_client' }
            checked={ defaultBulkRequestConfig?.uploaded_by == 'upload_file_client' }
            onChange={ e => handleDefaultBulkRequestConfig(e, 'uploaded_by') }
            invalid={ _.has(defaultBulkRequestConfig?.errors, 'uploaded_by') }
          />
          <Label
            className='form-check-label'
            for={ inputId(formName, 'uploaded_by_upload_file_client') }
          >
            { I18n.t('activerecord.attributes.corporate/bulk/request/agreement_document_config.uploaded_by.upload_file_client') }
          </Label>
        </div>
      )
    }
  }

  const uploadFileProviderRadio = () => {
    if(context == 'corporate'){
      return(
        <div className="form-check">
          <Input
            type='radio'
            className='form-check-input'
            name={ inputName(formName, 'uploaded_by') }
            id={ inputId(formName, 'uploaded_by_upload_file_provider') }
            value={ 'upload_file_provider' }
            checked={ defaultBulkRequestConfig?.uploaded_by == 'upload_file_provider' }
            onChange={ e => handleDefaultBulkRequestConfig(e, 'uploaded_by') }
            invalid={ _.has(defaultBulkRequestConfig?.errors, 'uploaded_by') }
          />
          <Label
            className='form-check-label'
            for={ inputId(formName, 'uploaded_by_upload_file_provider') }
          >
            { I18n.t('activerecord.attributes.corporate/bulk/request/agreement_document_config.uploaded_by.upload_file_provider') }
          </Label>
        </div>
      )
    }
  }

  // ------------------ Start ControlDocForms Template ------------------

  const controlDocFormTemplateRadio = () => {
    return(
      <div className="form-check">
        <Input
          type='radio'
          className='form-check-input'
          name={ inputName(formName, 'uploaded_by') }
          id={ inputId(formName, 'template') }
          value={ 'controldoc_form_template' }
          checked={ defaultBulkRequestConfig?.uploaded_by == 'controldoc_form_template' }
          onChange={ e => handleDefaultBulkRequestConfig(e, 'uploaded_by') }
          invalid={ _.has(defaultBulkRequestConfig.errors, 'uploaded_by') }
        />
        <Label
          className='form-check-label'
          for={ inputId(formName, 'template') }
        >
          { I18n.t('activerecord.attributes.laboral/document_type.uploaded_by.upload_controldoc_form') }
        </Label>
      </div>
    )
  }

  const controlDocFormCompletedByInput = () => {
    if(defaultBulkRequestConfig.uploaded_by == 'controldoc_form_template'){
      return(
        <FormGroup className='ml-3'>
          <div className="form-check">
            <Input
              type='radio'
              className='form-check-input'
              name={ inputName(formName, 'completed_by_entity') }
              id={ inputId(formName, 'completed_by_entity') }
              value={ "entity" }
              checked={ defaultBulkRequestConfig?.completed_by == 'entity' }
              onChange={ e => handleDefaultBulkRequestConfig(e, 'completed_by') }
            />
            <Label
              className='form-check-label'
              for={ inputId(formName, 'completed_by_entity') }
            >
              { I18n.t('activerecord.attributes.laboral/document_type.completed_by_entity') }
            </Label>
          </div>

          <div className="form-check">
            <Input
              type='radio'
              className='form-check-input'
              name={ inputName(formName, 'completed_by_system') }
              id={ inputId(formName, 'completed_by_system') }
              value={ "system" }
              checked={ defaultBulkRequestConfig.completed_by == 'system' }
              onChange={ e => handleDefaultBulkRequestConfig(e, 'completed_by') }
            />
            <Label
              className='form-check-label'
              for={ inputId(formName, 'completed_by_system') }
            >
              { I18n.t('activerecord.attributes.laboral/document_type.completed_by_system') }
            </Label>
          </div>

          <div className="form-check">
            <Input
              type='radio'
              className='form-check-input'
              name={ inputName(formName, 'completed_by_third_party') }
              id={ inputId(formName, 'completed_by_third_party') }
              value={ "third_party" }
              checked={ defaultBulkRequestConfig?.completed_by == "third_party" }
              onChange={ e => handleDefaultBulkRequestConfig(e, 'completed_by') }
            />
            <Label
              className='form-check-label'
              for={ inputId(formName, 'completed_by_true') }
            >
              { I18n.t('activerecord.attributes.laboral/document_type.completed_by_third_party') }
            </Label>
          </div>
        </FormGroup>
      )
    }
  }

  const thirdPartyEmailInput = () => {
    if(defaultBulkRequestConfig.uploaded_by == 'controldoc_form_template' && defaultBulkRequestConfig.completed_by == 'third_party'){
      return (
        <FormGroup>
          <FieldError errors={ defaultBulkRequestConfig?.errors?.third_party_email || [] }>
            <Label
              for={ inputId(formName, 'third_party_email') }
              className="required"
            >
              { I18n.t('activerecord.attributes.laboral/document_type.third_party_email') }
            </Label>
            <Input
              type='email'
              id={ inputId(formName, `third_party_email`) }
              name={ inputName(formName, 'third_party_email') }
              onChange={ e => handleConfigData(e, 'third_party_email') }
              invalid={ _.has(defaultBulkRequestConfig?.errors, 'third_party_email') }
            />
          </FieldError>
        </FormGroup>
      )
    }
  }

  const controlDocFormTemplateSelect = () => {
    if(defaultBulkRequestConfig.uploaded_by == 'controldoc_form_template'){
      return(
        <div className="row">
          <div className="col-12">
            <FormGroup>
              <FieldError errors={ defaultBulkRequestConfig?.errors?.template_id || [] }>
                <Label
                  for={ inputId(formName, 'template_id') }
                >
                  { I18n.t('activerecord.attributes.default_bulk_request_config.template_id') }
                </Label>

                <Select
                  id={ inputId(formName, 'template_id') }
                  name={ inputName(formName, 'template_id') }
                  value={ controlDocFormTemplateSelectedOption }
                  onChange={ e => handleDefaultBulkRequestConfig({ target: { value: e?.value } }, "template_id") }
                  options={ controlDocFormTemplateSelectOptions }
                  isClearable={ true }
                  placeholder={ '-- Selecciona una plantilla --' }
                  invalid={ _.has(defaultBulkRequestConfig?.errors, 'template_id') }
                />
              </FieldError>
            </FormGroup>
          </div>
        </div>
      )
    }
  }

  const controlDocFormTemplateSelectedOption = useMemo(() => {
    let selected = _.find(data?.templates || [] , { id: defaultBulkRequestConfig?.template_id })

    if(selected){
      return { label: selected?.name, value: selected?.id }
    } else {
      return null
    }
  }, [defaultBulkRequestConfig?.template_id])

  const controlDocFormTemplateSelectOptions = useMemo(() => {
    return _.map(data?.templates || [], function(template){
      return { value: template.id, label: template.name }
    })
  }, [])

  return(
    <div className="row">
      <div className="col-12">
        <div className="card card-outline card-primary">
          <div className="card-header">
            Configuración predeterminada
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                { uploadFileUserRadio() }
                { uploadFileEmployeeRadio() }
                { uploadFileClientRadio() }
                { uploadFileProviderRadio() }
                { controlDocFormTemplateRadio() }

                { controlDocFormCompletedByInput() }
                { thirdPartyEmailInput() }
                { controlDocFormTemplateSelect() }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default RequireDefaultBulkRequestConfigForm;
